import { useEffect, useState } from 'react';
import { buildNiagaraTree } from '../helpers/inventoryList';

/**
 * Builds a tree, scoped to an optional subtree, while avoiding unnecessary
 * rebuild calls by memoizing the results on the provided `treeCacheId`
 */
export default function useTree(devicesHash, { rootId, treeCacheId }) {
    const [tree, setTree] = useState([]);

    useEffect(() => {
        setTree(buildNiagaraTree(devicesHash, {
            rootId
        }));
    }, [devicesHash, rootId, treeCacheId]);

    return tree;
}
